var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isEdit ||
    _vm.sendStatus == null ||
    (_vm.sendStatus >= 0 && _vm.sendStatus <= 60) ||
    (_vm.sendStatus >= 1010 && _vm.sendStatus <= 1050)
      ? _c(
          "div",
          { staticClass: "form-section" },
          [
            _c("div", { staticClass: "section-title" }, [_vm._v("发起信息")]),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _vm.isEdit
                  ? _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-form-item", { attrs: { label: "发货单据号" } }, [
                          _c("span", { staticClass: "readonly-text" }, [
                            _vm._v(_vm._s(_vm.form.deliveryNo || "-")),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEdit
                  ? _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-form-item", { attrs: { label: "发起人" } }, [
                          _c("span", { staticClass: "readonly-text" }, [
                            _vm._v(_vm._s(_vm.initiator || "-")),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEdit
                  ? _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-form-item", { attrs: { label: "发起时间" } }, [
                          _c("span", { staticClass: "readonly-text" }, [
                            _vm._v(_vm._s(_vm.initiateTime || "-")),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: _vm.isEdit ? "" : "deliveryType",
                          label: "发货方式",
                        },
                      },
                      [
                        _vm.isEdit
                          ? _c("span", { staticClass: "readonly-text" }, [
                              _vm._v(_vm._s(_vm.form.deliveryType || "-")),
                            ])
                          : _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择发货方式" },
                                model: {
                                  value: _vm.form.deliveryType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "deliveryType", $$v)
                                  },
                                  expression: "form.deliveryType",
                                },
                              },
                              [
                                _vm.$parent.checkPer([
                                  "admin",
                                  "delivery:delivery",
                                ])
                                  ? _c("el-option", {
                                      attrs: {
                                        label: "配送(到家)",
                                        value: "配送(到家)",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$parent.checkPer([
                                  "admin",
                                  "delivery:delivery",
                                ])
                                  ? _c("el-option", {
                                      attrs: {
                                        label: "配送(到物流点)",
                                        value: "配送(到物流点)",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$parent.checkPer([
                                  "admin",
                                  "delivery:otherSend",
                                ])
                                  ? _c("el-option", {
                                      attrs: { label: "自提", value: "自提" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$parent.checkPer([
                                  "admin",
                                  "delivery:otherSend",
                                ])
                                  ? _c("el-option", {
                                      attrs: { label: "物流", value: "物流" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$parent.checkPer([
                                  "admin",
                                  "delivery:otherSend",
                                ])
                                  ? _c("el-option", {
                                      attrs: { label: "快递", value: "快递" },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$parent.checkPer([
                                  "admin",
                                  "delivery:otherSend",
                                ])
                                  ? _c("el-option", {
                                      attrs: { label: "闪送", value: "闪送" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: _vm.isEdit ? "" : "pickupDate",
                          label: "期望提货日期",
                        },
                      },
                      [
                        _vm.isEdit
                          ? _c("span", { staticClass: "readonly-text" }, [
                              _vm._v(_vm._s(_vm.form.pickupDate || "-")),
                            ])
                          : _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                placeholder: "选择日期",
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: _vm.form.pickupDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "pickupDate", $$v)
                                },
                                expression: "form.pickupDate",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: _vm.isEdit ? "" : "pickupTime",
                          label: "期望提货时间",
                        },
                      },
                      [
                        _vm.isEdit
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  Array.isArray(_vm.form.pickupTime)
                                    ? _vm.form.pickupTime.join(" - ")
                                    : _vm.form.pickupTime || "-"
                                )
                              ),
                            ])
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c("el-time-select", {
                                  attrs: {
                                    placeholder: "开始时间",
                                    "picker-options": {
                                      start: "08:00",
                                      step: "00:30",
                                      end: "20:00",
                                    },
                                  },
                                  model: {
                                    value: _vm.form.pickupTime[0],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form.pickupTime, 0, $$v)
                                    },
                                    expression: "form.pickupTime[0]",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { margin: "0 4px" } },
                                  [_vm._v("-")]
                                ),
                                _vm._v(" "),
                                _c("el-time-select", {
                                  attrs: {
                                    placeholder: "结束时间",
                                    "picker-options": {
                                      start: "08:00",
                                      step: "00:30",
                                      end: "20:00",
                                      minTime: _vm.form.pickupTime[0],
                                    },
                                  },
                                  model: {
                                    value: _vm.form.pickupTime[1],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form.pickupTime, 1, $$v)
                                    },
                                    expression: "form.pickupTime[1]",
                                  },
                                }),
                              ],
                              1
                            ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: _vm.isEdit ? "" : "licensePlate",
                          label: "车辆",
                        },
                      },
                      [
                        _vm.isEdit
                          ? _c("span", { staticClass: "readonly-text" }, [
                              _vm._v(_vm._s(_vm.form.licensePlate || "-")),
                            ])
                          : _c("el-input", {
                              attrs: {
                                placeholder: "请输入车牌，发货前可编辑",
                              },
                              model: {
                                value: _vm.form.licensePlate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "licensePlate", $$v)
                                },
                                expression: "form.licensePlate",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: _vm.isEdit ? "" : "driverName",
                          label: "司机姓名",
                        },
                      },
                      [
                        _vm.isEdit
                          ? _c("span", { staticClass: "readonly-text" }, [
                              _vm._v(_vm._s(_vm.form.driverName || "-")),
                            ])
                          : _c("el-input", {
                              attrs: {
                                placeholder: "请输入姓名，发货前可编辑",
                              },
                              model: {
                                value: _vm.form.driverName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "driverName", $$v)
                                },
                                expression: "form.driverName",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: _vm.isEdit ? "" : "driverPhone",
                          label: "司机电话",
                        },
                      },
                      [
                        _vm.isEdit
                          ? _c("span", { staticClass: "readonly-text" }, [
                              _vm._v(_vm._s(_vm.form.driverPhone || "-")),
                            ])
                          : _c("el-input", {
                              attrs: {
                                placeholder: "请输入手机，发货前可编辑",
                              },
                              model: {
                                value: _vm.form.driverPhone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "driverPhone", $$v)
                                },
                                expression: "form.driverPhone",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: _vm.isEdit ? "" : "receivePerson",
                          label: "收货人",
                        },
                      },
                      [
                        _vm.isEdit
                          ? _c("span", { staticClass: "readonly-text" }, [
                              _vm._v(_vm._s(_vm.form.receivePerson || "-")),
                            ])
                          : _c("el-input", {
                              attrs: { placeholder: "自动生成", readonly: "" },
                              model: {
                                value: _vm.form.receivePerson,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "receivePerson", $$v)
                                },
                                expression: "form.receivePerson",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: _vm.isEdit ? "" : "receivePhone",
                          label: "收货电话",
                        },
                      },
                      [
                        _vm.isEdit
                          ? _c("span", { staticClass: "readonly-text" }, [
                              _vm._v(_vm._s(_vm.form.receivePhone || "-")),
                            ])
                          : _c("el-input", {
                              attrs: { placeholder: "自动生成", readonly: "" },
                              model: {
                                value: _vm.form.receivePhone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "receivePhone", $$v)
                                },
                                expression: "form.receivePhone",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: _vm.isEdit ? "" : "receiveAddress",
                          label: "收货地址",
                        },
                      },
                      [
                        _vm.isEdit
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.form.receiveAddress || "-")),
                            ])
                          : _c(
                              "el-input",
                              {
                                attrs: {
                                  placeholder: "自动生成",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.form.receiveAddress,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "receiveAddress", $$v)
                                  },
                                  expression: "form.receiveAddress",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-location",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("open-address")
                                      },
                                    },
                                    slot: "append",
                                  },
                                  [_vm._v("选择收货地址")]
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "备注" } },
                      [
                        _vm.isEdit
                          ? _c("span", { staticClass: "readonly-text" }, [
                              _vm._v(_vm._s(_vm.form.remark || "-")),
                            ])
                          : _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 2,
                                placeholder: "请输入，限 200 个字符。",
                                maxlength: "200",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.form.remark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "remark", $$v)
                                },
                                expression: "form.remark",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "附件" } },
                      [
                        _vm.isEdit
                          ? [
                              _vm.previewAttachmentList.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "attachment-name-list" },
                                    [
                                      _vm._l(
                                        _vm.previewAttachmentList,
                                        function (item, idx) {
                                          return [
                                            item.isImage
                                              ? _c("el-image", {
                                                  key: "img" + idx,
                                                  staticStyle: {
                                                    width: "50px",
                                                    height: "50px",
                                                    "border-radius": "4px",
                                                  },
                                                  attrs: {
                                                    src: item.url,
                                                    "preview-src-list":
                                                      _vm.previewAttachmentList
                                                        .filter(function (i) {
                                                          return i.isImage
                                                        })
                                                        .map(function (i) {
                                                          return i.url
                                                        }),
                                                    fit: "cover",
                                                  },
                                                })
                                              : _c(
                                                  "span",
                                                  {
                                                    key: "file" + idx,
                                                    staticClass:
                                                      "attachment-name-item",
                                                    staticStyle: {
                                                      color: "#409EFF",
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.downloadAttachment(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(item.name))]
                                                ),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          : _c("CommonUpload", {
                              ref: "pickupAttachment",
                              on: {
                                uploadSuccess: _vm.handleAttachmentUpload,
                                delSuccess: _vm.handleAttachmentDel,
                              },
                            }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.sendStatus === 1010
      ? _c(
          "div",
          { staticClass: "form-section" },
          [
            _c("div", { staticClass: "section-title" }, [_vm._v("审核信息")]),
            _vm._v(" "),
            _c(
              "el-form",
              { attrs: { "label-width": "120px" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "客服审核" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 3,
                                placeholder: "请填写您的审批意见",
                              },
                              model: {
                                value: _vm.form.csAuditOpinion,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "csAuditOpinion", $$v)
                                },
                                expression: "form.csAuditOpinion",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "padding-top": "10px",
                        },
                        attrs: { span: 24 },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["admin", "customerService:audit"],
                                expression: "['admin','customerService:audit']",
                              },
                            ],
                            attrs: { type: "danger", loading: _vm.auditing },
                            on: { click: _vm.handleReject },
                          },
                          [_vm._v("驳回")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["admin", "customerService:audit"],
                                expression: "['admin','customerService:audit']",
                              },
                            ],
                            attrs: { type: "success", loading: _vm.auditing },
                            on: { click: _vm.handleApprove },
                          },
                          [_vm._v("同意")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.sendStatus > 1010
      ? _c(
          "div",
          { staticClass: "form-section" },
          [
            _c("div", { staticClass: "section-title" }, [_vm._v("审核信息")]),
            _vm._v(" "),
            _c(
              "el-form",
              { attrs: { "label-width": "100px" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-form-item", { attrs: { label: "审核结果" } }, [
                          _c(
                            "span",
                            {
                              style: {
                                color:
                                  _vm.deliveryLog &&
                                  _vm.deliveryLog.audit_step === "1011"
                                    ? "#F56C6C"
                                    : "#67C23A",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.deliveryLog &&
                                    _vm.deliveryLog.audit_step === "1011"
                                    ? "驳回"
                                    : "同意"
                                )
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-form-item", { attrs: { label: "审核人" } }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                (_vm.deliveryLog &&
                                  (_vm.deliveryLog.audit_createByName ||
                                    _vm.deliveryLog.audit_createBy)) ||
                                  "-"
                              )
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-form-item", { attrs: { label: "审核时间" } }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                (_vm.deliveryLog &&
                                  _vm.deliveryLog.audit_createTime) ||
                                  "-"
                              )
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-form-item", { attrs: { label: "审核意见" } }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                (_vm.deliveryLog &&
                                  _vm.deliveryLog.audit_remark) ||
                                  _vm.form.csAuditOpinion ||
                                  "-"
                              )
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isEdit && (_vm.sendStatus === 1040 || _vm.sendStatus === 1050)
      ? _c(
          "div",
          { staticClass: "form-section" },
          [
            _c("div", { staticClass: "section-title" }, [_vm._v("发货信息")]),
            _vm._v(" "),
            _vm.sendStatus === 1050
              ? _c(
                  "el-form",
                  { attrs: { "label-width": "100px" } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c("el-form-item", { attrs: { label: "发货人" } }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.deliveryLog.createByName ||
                                      _vm.deliveryLog.createBy ||
                                      "-"
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "发货时间" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.deliveryLog.createTime || "-")
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "发货清单" } },
                              [
                                _vm.deliveryChecklistPhotoList.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-wrap": "wrap",
                                          gap: "4px",
                                        },
                                      },
                                      _vm._l(
                                        _vm.deliveryChecklistPhotoList,
                                        function (img, idx) {
                                          return _c("el-image", {
                                            key: idx,
                                            staticStyle: {
                                              width: "50px",
                                              height: "50px",
                                              "border-radius": "4px",
                                            },
                                            attrs: {
                                              src: img.url,
                                              "preview-src-list":
                                                _vm.deliveryChecklistPhotoList.map(
                                                  function (i) {
                                                    return i.url
                                                  }
                                                ),
                                              fit: "cover",
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "装车完成图" } },
                              [
                                _vm.deliveryLoadingCompletePhotoList.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-wrap": "wrap",
                                          gap: "4px",
                                        },
                                      },
                                      _vm._l(
                                        _vm.deliveryLoadingCompletePhotoList,
                                        function (img, idx) {
                                          return _c("el-image", {
                                            key: idx,
                                            staticStyle: {
                                              width: "50px",
                                              height: "50px",
                                              "border-radius": "4px",
                                            },
                                            attrs: {
                                              src: img.url,
                                              "preview-src-list":
                                                _vm.deliveryLoadingCompletePhotoList.map(
                                                  function (i) {
                                                    return i.url
                                                  }
                                                ),
                                              fit: "cover",
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "el-form",
                  { attrs: { "label-width": "120px" } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "发货清单" } },
                              [
                                _c("CommonUpload", {
                                  ref: "checklistPhotoUpload",
                                  on: {
                                    uploadSuccess:
                                      _vm.handleChecklistPhotoUpload,
                                    delSuccess: _vm.handleChecklistPhotoDel,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "装车完成图" } },
                              [
                                _c("CommonUpload", {
                                  ref: "loadingCompletePhotoUpload",
                                  on: {
                                    uploadSuccess:
                                      _vm.handleLoadingCompletePhotoUpload,
                                    delSuccess:
                                      _vm.handleLoadingCompletePhotoDel,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "text-align": "center",
                              "padding-top": "10px",
                            },
                            attrs: { span: 24 },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  loading: _vm.submitting,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("delivery-submit")
                                  },
                                },
                              },
                              [_vm._v("提交")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isEdit
      ? _c(
          "div",
          { staticClass: "form-actions" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", loading: _vm.submitting },
                on: {
                  click: function ($event) {
                    return _vm.$emit("save", 10)
                  },
                },
              },
              [_vm._v("提交")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", loading: _vm.submitting },
                on: {
                  click: function ($event) {
                    return _vm.$emit("save", -1)
                  },
                },
              },
              [_vm._v("暂存")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("cancel")
                  },
                },
              },
              [_vm._v("取消")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "delivery-notice" }, [
      _c("div", { staticClass: "notice-title" }, [_vm._v("重要提醒")]),
      _vm._v(" "),
      _c("div", { staticClass: "notice-content" }, [
        _c("p", [_vm._v("1、为了给您提供更好的服务，请您审慎进行发货申请；")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "2、当您选择自提发货时，提货车辆应提前 20 分钟到达（如：您的期望提货时间是 09:00–10:00，您的提货车辆应在 08:40 前到达），如您超时到达，您的提货申请可能被滞后或取消；"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "3、当您选择自提发货时，在期望提货日期未提货，也未提前 1 天取消申请，您将需要支付仓库空等费 300 元 / 次，费用在您下次申请发货时支付；"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "4、请您充分告知提货人员，务必与仓库当面清点产品包数，以免对您的订单交付造成影响。"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }